import { CURRENCY_ISO, FORMATTING_LOCALE_CODE } from "~/utils/constants";
import { NumberFormatter as NF } from "~/common/utils/NumberFormatter";

interface CurrencyFormatOptions {
  prefix: string;
  suffix: string;
}

export const CURRENCY_FORMATTER: {
  [currency: string]: CurrencyFormatOptions;
} = {
  EUR: {
    prefix: "€ ",
    suffix: "",
  },
  USD: {
    prefix: "$ ",
    suffix: "",
  },
  GBP: {
    prefix: "£ ",
    suffix: "",
  },
  NOK: {
    prefix: "",
    suffix: " kr",
  },
  DKK: {
    prefix: "",
    suffix: " kr.",
  },
  SEK: {
    prefix: "",
    suffix: " kr",
  },
};

export function formatCurrency(
  amount: number | string,
  currencyCode: string = CURRENCY_ISO,
  locale: string = FORMATTING_LOCALE_CODE,
) {
  let amountStr;
  if (typeof amount === "number") {
    amountStr = NF.getPriceFormatter().format(amount);
  } else {
    amountStr = amount;
  }
  const currencyOptions = CURRENCY_FORMATTER[currencyCode];
  if (currencyOptions) {
    const { prefix, suffix } = currencyOptions;
    return prefix + amountStr + suffix;
  } else {
    return `${currencyCode} ${amountStr}`;
  }
}

export const formatCurrencyShort = (
  value: number | string,
  currencyCode: string = CURRENCY_ISO,
  placement: "start" | "end" = "start",
) => {
  const amount = Number(value);

  let amountStr: string;

  if (amount >= 1_000_000_000) {
    const val = truncateToNDecimals(amount / 1_000_000_000, 2);
    amountStr = val.toFixed(2).replace(/\.00$/, "") + "B";
  } else if (amount >= 1_000_000) {
    const val = truncateToNDecimals(amount / 1_000_000, 2);
    amountStr = val.toFixed(2).replace(/\.00$/, "") + "M";
  } else if (amount >= 1_000) {
    const val = truncateToNDecimals(amount / 1_000, 2);
    amountStr = val.toFixed(2).replace(/\.00$/, "") + "K";
  } else {
    amountStr = amount.toString();
  }

  const currencyOptions = CURRENCY_FORMATTER[currencyCode];

  if (currencyOptions) {
    const { prefix } = currencyOptions;
    return placement == "start" ? `${prefix} ${amountStr}` : `${amountStr} ${prefix}`;
  }

  return placement == "start" ? `${currencyCode} ${amountStr}` : `${amountStr} ${currencyCode}`;
};

export const truncateToNDecimals = (value: number, n: number) => {
  const factor = Math.pow(10, n);
  return Math.floor(value * factor) / factor;
};
